import { colors } from '@shared/tokens/colors.stylex';
import React from 'react';

interface PlusInCircleIconProps {
  color?: string;
  width?: string;
  height?: string;
}

export const PlusInCircleIcon: React.FC<PlusInCircleIconProps> = ({
  color = colors.inverseIcon,
  width = '20',
  height = '20',
}) => {
  return (
    <svg width={width} height={height} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M10 7.18755V12.8124" stroke={color} strokeLinecap="round" strokeLinejoin="round" />
      <path d="M7.18701 10H12.8119" stroke={color} strokeLinecap="round" strokeLinejoin="round" />
      <path
        d="M9.99987 17C13.8748 17 16.9998 13.8749 16.9998 10C16.9998 6.12507 13.8748 3 9.99987 3C6.12493 3 3 6.12507 3 10C3 13.8749 6.12493 17 9.99987 17Z"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
